import React from 'react';
import * as classes from './Navbar.module.css';
import { StaticImage } from "gatsby-plugin-image";
import { Link } from 'gatsby';

function Navbar() {
  return (
    <div className={classes.navbarContainer}>
      <div className={classes.navbarContentContainer}>
        <Link to="/">
          <div style={{ marginRight: 10, display: 'flex', alignItems: 'center' }}>
            {/* <Icon style={{ height: 50, width: 50 }} /> */}
             <StaticImage
        src="../../images/logo.jpg"
        alt="Recover Logo"
        placeholder="blurred"
        style={{ height: 50, width: 50 }}
      />
            <span className={classes.siteName}>Techno Tools Apps</span>
          </div></Link>
      </div>
    </div>
  )
}

export default Navbar;